<div mat-dialog-content>
    <p> Upload Profile Pic For <span class="userName">{{this.userService?.currentUser?.firstName}} {{this.userService?.currentUser?.lastName}}</span></p>
  </div>
  
  <div mat-dialog-actions>
    <app-upload-file class="form-control" [modelId]="this.userService?.currentUser?.id" model="users" field="profile_picture" updatedEndpoint="/upload_image/"></app-upload-file>
  </div>
  